export const enviarcheckin = {
    text1: "Check-in senden",
    text2: "Senden Sie einen Link, damit Ihre Gäste vor der Ankunft in der Unterkunft einchecken können.",
    text3: "Unterkunft auswählen *",
    text4: "Namen eingeben",
    text5: "Name des Gastes *",
    text6: "Telefonnummer des Gastes *",
    text7: "E-Mail",
    text8: "E-Mail des Gastes *",
    text9: "Senden",
    text09: "Planen",
    text10: "Check-in wird gesendet, bitte warten Sie",
    text11: "Sie müssen eine Unterkunft auswählen, um den Check-in zuzuweisen",
    text12: "Das Feld Name ist erforderlich",
    text13: "Das Feld Telefon ist erforderlich",
    text14: "Die E-Mail ist erforderlich",
    text15: "Fast geschafft",
    text16: "Hallo ",
    text17: "! Hier ist ",
    text18: ". Wir senden Ihnen diese Nachricht, damit Sie schon vor der Ankunft in unserer Unterkunft einchecken können. So vermeiden Sie Wartezeiten an der Rezeption und vor allem unnötigen Papierverbrauch. \n\nFür einen grüneren Planeten!",
    text19: "Hallo ",
    text20: "! Hier ist ",
    text21: ". Wir senden Ihnen diese Nachricht, damit Sie schon vor der Ankunft in unserer Unterkunft einchecken können. So vermeiden Sie Wartezeiten an der Rezeption und vor allem unnötigen Papierverbrauch. <br> <br> Für einen grüneren Planeten!",
    text22: "Check-in erfolgreich gesendet",
    text23: "Wird geladen ...",

    // Corrections
    p1: "Check-in-Link senden",
    p2: "Buchung erstellen",
    p3: "Angaben zur Buchung",
    p4: "Name des verantwortlichen Gastes",
    p5: "Check-in-Datum",
    p6: "Check-out-Datum",
    p7: "Anzahl der Gäste",
    p8: "Zimmer auswählen",
    p9: "Nicht angegeben",
    p10: "Zimmernummer auswählen",
    p11: "Online-Check-in",
    p12: "Preis der Buchung",
    p13: "Buchung erstellen",
    p14:`Laden Sie Ihren Gast jetzt ein, den Check-in durchzuführen.`,
    p15:`Zusätzliche Gebühr`,

    p16:`Zimmer angeben`,
    p17:`Wenn Sie ein Zimmer auswählen, senden wir die zugehörigen Schlüssel mit`,
    p18:`Zimmer auswählen`,
    p19:`Keine Ergebnisse gefunden. Versuchen Sie einen anderen Begriff.`,
    p20:`Keine Zimmer verfügbar.`,
    p21:`Zum Auswählen Enter drücken`,
    p22:`Ausgewählt`,
    p23:`Zum Entfernen Enter drücken`,
    p24:`Keine Optionen verfügbar`,
    p25: `Buchung erfolgreich erstellt.`,
    p26: `Die Buchung wurde erfolgreich abgeschlossen. Sie können zur Startseite zurückkehren.`,
    p27: `Einladung erfolgreich gesendet.`,
    p28: `OK`,
};
